import { useState } from "react";
import { listIdentities, signInAs } from "../auth/demo-auth";

interface Props {
  onSignedIn: () => void;
}

/**
 * Demo-mode login: no SMS, no Cognito. The visitor picks which seeded hasher to
 * be — admin, a kennel misman, or a plain hasher — so they can experience each
 * permission level. Selecting an identity persists it to client storage and
 * hands off to the app exactly like a real sign-in.
 */
export function DemoLogin({ onSignedIn }: Props) {
  const [fadeOut, setFadeOut] = useState(false);
  const identities = listIdentities();

  const enter = (hasherId: string) => {
    signInAs(hasherId);
    setFadeOut(true);
    setTimeout(() => onSignedIn(), 250);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-slate-50">
      <div
        className={`w-full max-w-sm bg-white rounded-2xl shadow-sm p-6 transition-all duration-300 ${
          fadeOut ? "opacity-0 scale-95" : "opacity-100 scale-100"
        }`}
      >
        <h1 className="text-2xl font-bold text-slate-900">Hash Attendance</h1>
        <span className="mt-1 inline-block rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
          Demo
        </span>
        <p className="mt-4 text-sm text-slate-600">
          Pick someone to sign in as. Everything runs in your browser — no
          account, no texts. Your changes are saved on this device and you can
          reset the demo data anytime from the menu.
        </p>

        <ul className="mt-5 space-y-3">
          {identities.map((id) => (
            <li key={id.hasherId}>
              <button
                onClick={() => enter(id.hasherId)}
                className="w-full text-left rounded-xl border border-slate-200 px-4 py-3 min-h-[44px] hover:border-slate-400 hover:bg-slate-50 active:bg-slate-100 transition-colors"
              >
                <div className="flex items-baseline justify-between gap-2">
                  <span className="font-medium text-slate-900">{id.name}</span>
                  <span className="text-xs text-slate-400">{id.kennel}</span>
                </div>
                <span className="mt-0.5 block text-sm text-slate-600">
                  {id.blurb}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
